import { useUpdateAssignmentMarkMutation } from "../../redux/features/assignment/assignmentApi";


export default function AssMarkForm({ id, totalMark }) {
    const [updateAssignmentMark, { isLoading }] = useUpdateAssignmentMarkMutation()

    const submitHandler = (e) => {
        e.preventDefault();
        const data = {
            status: "published",
            mark: Number(e.target.elements["mark"].value)
        }
        updateAssignmentMark({ id, data })
    }
    return (
        <td className="table-td input-mark">
            <form onSubmit={submitHandler}>
                <input max={totalMark} name="mark" type="number" />
                <button disabled={isLoading} className="" type="submit">
                    <svg fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"
                        className="w-6 h-6 text-green-500 cursor-pointer hover:text-green-400">
                        <path strokeLinecap="round" strokeLinejoin="round"
                            d="M4.5 12.75l6 6 9-13.5" />
                    </svg>
                </button>
            </form>
        </td>
    )
};